import { AuthenticatedTemplate } from "@azure/msal-react";

import { NavigationBar } from "./navigation-bar";

export const PageLayout = (props) => {
  return <div className="min-h-screen">{props.children}</div>;
};
